<div class="card card-radius m-0 relative">
  <button class="close-btn" aria-label="close" tabindex="-1" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>

  <h2 class="text-xxl text-bold text-center mb-5">{{ data.title }}</h2>

  <div class="mb-5 message">{{ data.message }}</div>

  <div class="d-flex justify-content-center">
    <button class="btn btn-primary mb-3" type="submit" tabindex="0" (click)="handleConfirmClick()">
      {{ data.confirmText }}
    </button>
  </div>
</div>
